import api from '../axios';

export async function getJornadaMembro(membroId) {
  const res = await api.get(`/jornada/membro/${membroId}`);
  return res.data;
}

export async function atualizarJornada(membroId, data) {
  const res = await api.put(`/jornada/membro/${membroId}`, data);
  return res.data;
}

export async function membrosSemAcompanhamento() {
  const res = await api.get('/jornada/membros-sem-acompanhamento');
  return res.data;
}

export async function lideresSemDiscipulador() {
  const res = await api.get('/jornada/lideres-sem-discipulador');
  return res.data;
}
